import React from 'react';

import { usePageStore } from '@client/store/pageStore/context/pageContext';
import { SpectrogramMapItem } from '@ledium/types';
import { Grid } from '@mui/material';

import ProjectEditorSpectrumMixSelector from './ProjectEditorSpectrumMixSelector';

const ProjectEditorSpectrumMixList = () => {
    const {
        pageState: { formData },
        pageActions
    } = usePageStore();

    function onSpectrumMixSelect(lightRecipeId: string, spectrumMixId: string | null) {
        const spectrogramMap = (formData.spectrogramMap as SpectrogramMapItem[]).map((spectrogramMapItem) =>
            spectrogramMapItem.lightRecipeId === lightRecipeId && spectrogramMapItem.spectrumMixId !== spectrumMixId
                ? { ...spectrogramMapItem, spectrumMixId: spectrumMixId }
                : spectrogramMapItem
        );
        pageActions.formData.updateFormItem({ spectrogramMap });
    }

    return (
        <>
            {(formData.spectrogramMap as SpectrogramMapItem[]).map((spectrogramMapItem) => (
                <Grid mb={3} item xs={12} key={`mix-${spectrogramMapItem.lightRecipeId}`}>
                    <ProjectEditorSpectrumMixSelector
                        lightRecipeId={spectrogramMapItem.lightRecipeId}
                        spectrumMixId={spectrogramMapItem.spectrumMixId}
                        onSpectrumMixSelect={onSpectrumMixSelect}
                        readOnly={!!formData.readOnly}
                        projectId={formData.id}
                    />
                </Grid>
            ))}
        </>
    );
};

export default ProjectEditorSpectrumMixList;
